/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {DiplomatObject} from './DiplomatObject';

export const SessionData = DiplomatObject.shape({
   sessionTimeout: yup.number().integer().min(0).required(),
});
export type ISessionData = yup.InferType<typeof SessionData>;
